import * as React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import renderLog from '../utils/renderCount';
import { Logo } from '../misc/Logo';
import { useTheme } from '../data-mediation';

const Content = React.memo(({ children }: React.PropsWithChildren) => {
  renderLog('Content');
  const theme = useTheme();

  return (
    <Box
      flex="1 1 auto"
      height="100%"
      width="100%"
      flexDirection="row"
      alignItems="center"
      extend={() => ({
        '& *': {
          scrollbarWidth: 'none',
          '-ms-overflow-style': 'none',
        },
        '& *::-webkit-scrollbar': { display: 'none' },
      })}
    >
      <Logo logoUrl={theme?.logo_cropped_image_url} />
      {children}
    </Box>
  );
});

export default Content;
